<template>
    <v-toolbar color="primary" dark fixed app>
        <v-toolbar-side-icon @click.stop="handleDrawerToggle"></v-toolbar-side-icon>
        <v-toolbar-items class="hidden-lg-and-up">
            <v-btn :to="{name: 'home'}" flat class="hidden-lg-and-up"><v-icon>home</v-icon></v-btn>
        </v-toolbar-items>
        <v-toolbar-items class="hidden-md-and-down">
            <v-btn flat :to="{name: 'home'}"><v-icon>home</v-icon></v-btn>
            <v-btn flat :to="{name: 'catalogue'}">{{$t('message.256')}}</v-btn>
            <v-btn flat :to="{name: 'part'}">{{$t('message.150')}}</v-btn>
            <v-btn flat :to="{name: 'interchange'}">{{$t('message.243')}}</v-btn>
            <v-btn flat :to="{name: 'tecdoc'}">TecDoc</v-btn>
            <v-btn flat :to="{name: 'arrivals'}">{{$t('message.314')}}</v-btn>
        </v-toolbar-items>
        <v-spacer></v-spacer>
        <template v-if="$auth.check()">
            <v-menu offset-y>
                <v-btn slot="activator" flat>
                    <v-icon dark>arrow_drop_down</v-icon>
                    {{$auth.user().fullName}}
                </v-btn>
                <v-list>
                    <v-list-tile @click="logout">
                        <v-list-tile-action>
                            <v-icon small>fa-sign-out-alt</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-title>Logout</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile :to="{name: 'change'}">
                        <v-list-tile-action>
                            <v-icon small>fa-key</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-title>Change Password</v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>
            <v-badge overlap color="secondary">
                <span slot="badge" title="Quote Count">{{ count }}</span>
                <v-btn title="View Quote" icon :to="{name: 'quotes'}"><v-icon color="white" >shopping_cart</v-icon> </v-btn>
            </v-badge>
        </template>
        <template v-else>
            <v-btn flat :to="{name: 'login'}" title="Login"><v-icon small left>fa-sign-in-alt</v-icon>Login</v-btn>
            <v-btn flat :to="{name: 'register'}" title="Register"><v-icon small left>fa-user-plus</v-icon>Register</v-btn>
        </template>
        <v-menu :nudge-width="100">
            <v-btn slot="activator" flat>
                {{ currentLanguage() }}
            </v-btn>
            <v-list>
                <v-list-tile v-for="(lang, i) in langs" :key="`Lang${i}`" @click="handleLanguageChange(lang.locale)">
                    <v-list-tile-title v-text="$t(lang.messageId)"></v-list-tile-title>
                </v-list-tile>
            </v-list>
        </v-menu>
        <v-btn icon @click="handleFullScreen()" title="Toggle Full Screen">
            <v-icon>fullscreen</v-icon>
        </v-btn>
    </v-toolbar>
</template>

<script>
import Util from '@/util'
import { loadLanguageAsync } from '@/localization'
import { mapGetters, mapActions } from 'vuex'
import { CurrencyConfigEN, CurrencyConfigEU } from '../models/consts'

export default {
  name: 'AppToolbar',
  data () {
    return {
      langs: [
        { name: 'Czech', messageId: 'message.344', locale: 'cs' },
        { name: 'Dutch', messageId: 'message.224', locale: 'nl' },
        { name: 'English', messageId: 'message.217', locale: 'en' },
        { name: 'French', messageId: 'message.208', locale: 'fr' },
        { name: 'German', messageId: 'message.201', locale: 'de' },
        { name: 'Italian', messageId: 'message.187', locale: 'it' },
        { name: 'Norwegian', messageId: 'message.164', locale: 'no' },
        { name: 'Polish', messageId: 'message.147', locale: 'pl' },
        { name: 'Portuguese', messageId: 'message.348', locale: 'pt' },
        { name: 'Slovak', messageId: 'message.343', locale: 'sk' },
        { name: 'Spanish', messageId: 'message.128', locale: 'es' }
      ]
    }
  },
  mounted () {
    this.$events.on('APP_LOGIN_SUCCESS', eventData => {
      // Load quotes for the logged in user
      this.load(this)
    })
  },
  computed: mapGetters(
    'quote', {
      count: 'count'
    }
  ),
  methods: {
    ...mapActions(
      'quote', {
        load: 'load'
      }
    ),
    handleDrawerToggle () {
      this.$events.emit('APP_DRAWER_TOGGLED', null)
    },
    handleFullScreen () {
      Util.toggleFullScreen()
    },
    currentLanguage () {
      if (this.$i18n.locale) {
        let index = this.langs.findIndex(obj => obj.locale === this.$i18n.locale)
        if (index > -1) {
          return this.$t(this.langs[index].messageId)
        }
      }
      return null
    },
    handleLanguageChange (lang) {
      if (lang) {
        loadLanguageAsync(lang).then(() => this.$log.debug(`Language Changed: ${lang}`))
        this.$CurrencyFilter.setConfig((lang === 'en') ? CurrencyConfigEN : CurrencyConfigEU)
      }
    },
    logout () {
      this.$auth.logout({
        makeRequest: true,
        redirect: '/'
      }).then(() => {
        this.$snotify.success('Logged Out')
      }).catch(() => {
        this.$snotify.error('Error logging out')
      })
    }
  }
}
</script>

<style scoped>

</style>
